import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { push } from 'connected-react-router'

import { setAccessToken } from '../../../modules/auth/actions/creators'

import {
  setPrimaryInfo,
  displayProfileModal,
  setProfileModalPage,
  setAccountStatus,
} from '../../../modules/profile/actions/creators'

import {
  waitRenderServer,
  renderServer,
} from '../../../modules/ssr/actions/creators'

import ChangePasswordPage from '../components/ChangePasswordPage/ChangePasswordPage'

const mapStateToProps = reduxState => {
  const { auth, profile } = reduxState

  const { accessToken } = auth

  const { primaryInfo, showProfileModal, profileModalPage } = profile

  return {
    accessToken,
    primaryInfo,
    showProfileModal,
    profileModalPage,
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      setAccessToken,
      displayProfileModal,
      setProfileModalPage,
      waitRenderServer,
      renderServer,
      push,
      setPrimaryInfo,
      setAccountStatus,
    },
    dispatch,
  )

const ConnectedChangePasswordPage = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ChangePasswordPage)

export default ConnectedChangePasswordPage
